<div class="mt-4 wrapper-content">
  <div class="col-12">
    <p-card styleClass="px-5 mb-4 py-2 shadow-3">

      <h1 class="font-23 text-blue-general  mb-4">{{ translations.header }}</h1>
      <p-divider/>
      @for (item of politicaDatos; track $index) {
        <div class="text-left mb-5">
          <h2 class="font-18 text-blue-general  mb-2">{{ item.title }}</h2>
          <p class="line-height-3 font-16 text-justify">{{ item.content }}</p>
        </div>
      }
      <p-divider/>
      <div class="flex align-items-center gap-2">
        <a (click)="getDocumento()" class="cursor-pointer">
          <i class="pi pi-file-pdf text-4xl text-red-600 hover:text-red-100"></i>
        </a>
        <div>
          <h2 class="text-blue-general mt-0 mb-1">{{ translations.consultaDocumento }}</h2>
          <a class=" no-underline cursor-pointer text-blue-general"
             (click)="getDocumento()">{{ translations.nombreDocumento  }}</a>
        </div>
      </div>
    </p-card>
  </div>
</div>
